// extracted by mini-css-extract-plugin
export var messageSideLeft = "_sd-1";
export var stateContainer = "_sd-0";